// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list":"breadcrumbs__list--30oOG","item":"breadcrumbs__item--o0_wJ"};